/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Editor_Presence_More_OtherInputs */



/**
* | output |
* | --- |
* | "{count} more collaborators" |
*
* @param {Editor_Presence_More_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_presence_more_other = /** @type {((inputs: Editor_Presence_More_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Presence_More_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} weitere Mitarbeiter`)
	return /** @type {LocalizedString} */ (`${i?.count} more collaborators`)
});